import React from "react"
import Header from "../components/header"
import Layout from "../components/layout"
import Curso from "../components/curso"
import Pregunta from "../components/Pregunta"
import { useStaticQuery, graphql } from "gatsby"

const IndexPage = () => {
  const data = useStaticQuery(graphql`
    {
      allFile(filter: { relativeDirectory: { eq: "covers" } }) {
        edges {
          node {
            childImageSharp {
              fluid(quality: 100, maxWidth: 700) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  `)

  const imagenes = data.allFile.edges
  // console.log(imagenes)

  // console.log(imagenes[0].node.childImageSharp)

  return (
    <Layout>
      <Header
        titulo="Saca Máximo Provecho"
        subtitulo="a tus cursos"
        tagline="El orden para tomar los cursos dependerá de cual sea tu meta: aprender a programar, trabajar en una empresa, trabajar como freelancer o emprender un negocio digital"
      />
      <section className="aprende-desarrollo contenedor py3">
        <h2>
          <span> </span>
        </h2>
        <p>
          ¿Estás tomando mis cursos pero no sabes si vas en la dirección
          correcta?
        </p>

        <p>
          Lo más importante es definir tu meta: Aprender a Programar, Obtener un
          Trabajo como Desarrollador(a) de Software, Trabajar como Freelancer
          creando sitios web o Crear un Emprendimiento Digital.
        </p>

        <p>
          Muchas personas comparten cientos de certificados de cursos
          completados, pero no tienen una meta clara, estudiar en la dirección
          correcta es más importante que estudiar con gran empeño.
        </p>

        <p>
          Define tu meta y sigue los cursos según los siguientes planes o paths.
        </p>
      </section>

      <section className="bg-grisOscuro seccion-podcast py3">
        <div className="contenedor">
          <h2>
            Aprende<span>Las Bases - #codigoConJuan</span>
          </h2>
          <p className="tagline-cursos">
            Los siguientes cursos son la base de todos los cursos y si nunca has
            programado o no tienes experiencia con Programación, Bases de datos,
            Frameworks, HTML o CSS, deberás comenzar con ellos en el siguiente
            orden, NOTA: Si ya dominas alguna tecnología puedes saltar ese
            curso.
          </p>

          <div className="bg-blanco py2 px2 mt2 sombra">
            <ul className="lista-cursos">
              <Curso
                imagen={imagenes[5].node.childImageSharp.fluid}
                titulo="Introducción a la Programación con Python"
                descripcion="¿Deseas aprender Programación para obtener un mejor trabajo o crear una idea? ¡Este curso es para ti! Aprende que son variables, lenguajes de programación, estructuras de control, iteradores, Programación Orientada a Objetos y mucho más"
                videos="63"
                duracion="4.5"
                orden="1"
              />
              <Curso
                imagen={imagenes[1].node.childImageSharp.fluid}
                titulo="Fundamentos de Programación Web para Principiantes"
                descripcion="Introducción a la Programación Web, Lenguajes, Frameworks, BD, Herramientas utilizadas y como convertirte en Desarrollador Web"
                videos="30"
                duracion="2.5"
                orden="2"
              />
              <Curso
                imagen={imagenes[10].node.childImageSharp.fluid}
                titulo="Desarrollo Web Completo con HTML5, CSS3, JS AJAX PHP y MySQL"
                descripcion="Aprende Desarrollo Web con este curso 100% práctico, paso a paso y sin conocimientos previos, INCLUYE: Proyecto Final – Sitio de Conferencias con Registros de PayPal y una introducción y manos a la obra en las tecnologías más populares para la creación de sitios y aplicaciones web."
                videos="493"
                duracion="54"
                orden="3"
              />
              <Curso
                imagen={imagenes[0].node.childImageSharp.fluid}
                titulo="CSS Grid y Flexbox, La Guía Definitiva, Crea + 10 Proyectos"
                descripcion="CSS La Guia Definitiva, lleva tu aprendizaje de CSS al Siguiente Nivel con Proyectos! CSS Grid, CSS Avanzado y Flexbox, 10 proyectos recreando sitios web populares."
                videos="122"
                duracion="11"
                orden="4"
              />
              <Curso
                imagen={imagenes[4].node.childImageSharp.fluid}
                titulo="JavaScript Moderno Guía Definitiva Construye +15 Proyectos"
                descripcion="JavaScript paso de ser el lenguaje de la web a ser un lenguaje Full Stack, puedes crear sitios web en el frontend, backend, consultar bases de datos, apps móviles o de escritorio. Aprende el lenguaje de programación web más popular paso a paso creando Proyectos – Incluye Proyectos con JavaScript, React, Node.js, MERN, Electron, Webpack y mucho más"
                videos="338"
                duracion="32"
                orden="5"
              />
            </ul>
          </div>
        </div>

        <div className="contenedor  py3">
          <h2>
            ¿Deseas
            <span>Trabajar en una empresa o ser Desarrollador Full Stack?</span>
          </h2>
          <p className="tagline-cursos">
            A continuación hay una serie de cursos que te ayudarán a obtener un
            trabajo, con proyectos más avanzados que podrás mostrar a un
            reclutador como parte de tu portafolio. Recuerda una vez que has
            decidido dar el paso hacia una empresa debes demostrar que eres
            capaz de crear proyectos y escribir código.
          </p>

          <div className="bg-blanco py2 px2 mt2 sombra">
            <ul className="lista-cursos">
              <Curso
                imagen={imagenes[12].node.childImageSharp.fluid}
                titulo="React – La Guía Completa: Hooks Context Redux MERN +15 Apps"
                descripcion="Incluye React Hooks, Gatsby y GraphQL, Firestore, Redux, Context, MERN, Next.js, Styled Components, Custom Hooks Y MÁS!!, el curso más completo de React en Udemy"
                videos="556"
                duracion="41"
                orden="1"
              />
              <Curso
                imagen={imagenes[7].node.childImageSharp.fluid}
                titulo="Node.js – Bootcamp Desarrollo Web inc. MVC y REST API’s"
                descripcion="Aprende a Crear aplicaciones web fullstack con Node y Express, incluye Mongoose, Sequelize, Pug, Handlebars, autenticación de usuarios, envío de emails y ¡mucho más!"
                videos="337"
                duracion="34"
                orden="2"
              />
              <Curso
                imagen={imagenes[14].node.childImageSharp.fluid}
                titulo="React Native – Crea aplicaciones para Android y iOS c/ React"
                descripcion="Toma tus conocimientos de React y úsalos para aprender a crear apps para Android y iOS, React Native te permitirá escribir código una vez y crear ambas versiones"
                videos="264"
                duracion="19"
                orden="3"
              />
              <Curso
                imagen={imagenes[2].node.childImageSharp.fluid}
                titulo="React Avanzado: Fullstack Next.js, Apollo, MongoDB y GraphQL"
                descripcion="Construye una Aplicación Empresarial Completa c/ React, Next.js, GraphQL, Apollo Server, Client, MongoDB, Tailwind y Formik"
                videos="+200"
                duracion="26"
                orden="4"
              />
              <Curso
                imagen={imagenes[8].node.childImageSharp.fluid}
                titulo="Laravel 7 – Crea Aplicaciones y Sitios Web con PHP y MVC"
                descripcion="Aprende Laravel y Comienza a Crear Aplicaciones Web Dinámicas, Interactivas y Seguras con este curso, Laravel el framework MVC más popular en la actualidad - INCLUYE 3 PROYECTOS"
                videos="270"
                duracion="23"
                orden="5"
              />
            </ul>
          </div>
        </div>

        <div className="contenedor ">
          <h2>
            ¿Deseas
            <span>crear un emprendimiento digital?</span>
          </h2>
          <p className="tagline-cursos">
            Si deseas crear un emprendimiento digital necesitarás una
            herramienta para crear una aplicación web, móvil y una tienda
            virtual para recibir pagos; así como registro de usuarios y que
            administren su información, a continuación una serie de cursos que
            te ayudarán a impulsar tu idea.
          </p>

          <div className="bg-blanco py2 px2 mt2 sombra">
            <ul className="lista-cursos">
              <Curso
                imagen={imagenes[7].node.childImageSharp.fluid}
                titulo="Node.js – Bootcamp Desarrollo Web inc. MVC y REST API’s"
                descripcion="Aprende a Crear aplicaciones web fullstack con Node y Express, incluye Mongoose, Sequelize, Pug, Handlebars, autenticación de usuarios, envío de emails y ¡mucho más!"
                videos="337"
                duracion="34"
                orden="1"
              />
              <Curso
                imagen={imagenes[12].node.childImageSharp.fluid}
                titulo="React – La Guía Completa: Hooks Context Redux MERN +15 Apps"
                descripcion="Incluye React Hooks, Gatsby y GraphQL, Firestore, Redux, Context, MERN, Next.js, Styled Components, Custom Hooks Y MÁS!!, el curso más completo de React en Udemy"
                videos="556"
                duracion="41"
                orden="2"
              />
              <Curso
                imagen={imagenes[14].node.childImageSharp.fluid}
                titulo="React Native – Crea aplicaciones para Android y iOS c/ React"
                descripcion="Toma tus conocimientos de React y úsalos para aprender a crear apps para Android y iOS, React Native te permitirá escribir código una vez y crear ambas versiones"
                videos="264"
                duracion="19"
                orden="3"
              />
              <Curso
                imagen={imagenes[8].node.childImageSharp.fluid}
                titulo="Laravel 7 – Crea Aplicaciones y Sitios Web con PHP y MVC"
                descripcion="Aprende Laravel y Comienza a Crear Aplicaciones Web Dinámicas, Interactivas y Seguras con este curso, Laravel el framework MVC más popular en la actualidad - INCLUYE 3 PROYECTOS"
                videos="270"
                duracion="23"
                orden="4"
              />
              <Curso
                imagen={imagenes[6].node.childImageSharp.fluid}
                titulo="Desarrollo de Tiendas Virtuales con WordPress y WooCommerce"
                descripcion="WooCommerce es la plataforma para E-Commerce más popular, aprende a administrar tu tienda virtual como un profesional con este curso así como crear un tema con Storefront, aprende a recibir pagos en línea para productos físicos y virtuales."
                videos="125"
                duracion="10"
                orden="5"
              />
            </ul>
          </div>
        </div>

        <div className="contenedor py3">
          <h2>
            ¿Deseas<span>ofrecer sitios web como freelancer?</span>
          </h2>
          <p className="tagline-cursos">
            Antes de Udemy decidi ser Freelancer por 13 años, con los siguientes
            cursos aprenderás a cobrar por tu trabajo, desarrollar los proyectos
            de forma rápida y fácil para tus clientes.
          </p>

          <div className="bg-blanco py2 px2 mt2 sombra">
            <ul className="lista-cursos">
              <Curso
                imagen={imagenes[17].node.childImageSharp.fluid}
                titulo="Cómo ser un Freelancer Exitoso para Diseño y Desarrollo Web"
                descripcion="Aprende todo para ser Freelancer: Cómo obtener tu primer cliente, cuanto cobrar por tus servicios, elaborar un plan para crecer tu red de contactos, definir tu espacio de trabajo, consideraciones para recibir pagos, como identificar un nicho y ofrecer servicios en el, además: llegado el momento sabrás cuando incluir a más personas a tu equipo de trabajo y cobrar más."
                videos="69"
                duracion="5"
                orden="1"
              />

              <Curso
                imagen={imagenes[15].node.childImageSharp.fluid}
                titulo="Diseño y Desarrollo Web con Bootstrap 4 Incluye 8 Proyectos"
                descripcion="Bootstrap te permitirá crear sitios web más rápido, por lo que podrás mostrarle a tu cliente avances o el proyecto final más pronto."
                videos="218"
                duracion="18"
                orden="2"
              />
              <Curso
                imagen={imagenes[3].node.childImageSharp.fluid}
                titulo="WordPress Introducción Practica a Gutenberg el Nuevo Editor"
                descripcion="WordPress es mi herramienta favorita para trabajar mis proyectos de Freelancing, este curso es gratuito y te permitirá ver lo que WordPress ofrece, así como permitirle a tus clientes administrar su sitio web."
                videos="32"
                duracion="3"
                orden="3"
              />

              <Curso
                imagen={imagenes[16].node.childImageSharp.fluid}
                titulo="Desarrollo Profesional de Temas y Plugins de WordPress"
                descripcion="Aprende a crear Temas y Plugins de WordPress, convierte tus diseños en HTML estático a Sitios Web Dinamicos con WordPress, de esta forma podrás cobrar más así como darle todo el control de su sitio web a tus clientes."
                videos="406"
                duracion="36"
                orden="4"
              />
              <Curso
                imagen={imagenes[11].node.childImageSharp.fluid}
                titulo="Desarrollo de Temas de WordPress con Bootstrap 4 y CMB2"
                descripcion="CMB2 es un framework completo para WordPress, te permitirá crear sitios web y hasta aplicaciones web sobre WordPress sin aprender nuevas tecnologías como Node o Laravel, sin duda la mejor opción para quien desea crear un proyecto grande y tiene ya conocimientos en WordPress"
                videos="264"
                duracion="19"
                orden="5"
              />
              <Curso
                imagen={imagenes[6].node.childImageSharp.fluid}
                titulo="Desarrollo de Tiendas Virtuales con WordPress y WooCommerce"
                descripcion="WooCommerce es la plataforma para E-Commerce más popular, aprende a administrar tu tienda virtual como un profesional con este curso así como crear un tema con Storefront, aprende a recibir pagos en línea para productos físicos y virtuales."
                videos="125"
                duracion="10"
                orden="6"
              />
            </ul>
          </div>
        </div>

        <div className="contenedor">
          <h2>
            ¿Deseas
            <span>ser un experto en WordPress y vender Plugins o Temas?</span>
          </h2>
          <p className="tagline-cursos">
            Hace poco conocí a un desarrollador de Plugins de WordPress que
            ganaba 10 mil dolares cada mes gracias a un solo Plugin, WordPress
            es la herramienta más popular hoy en día para crear sitios web con
            un gran mercado, conviértete en un experto con estos cursos.
          </p>

          <div className="bg-blanco py2 px2 mt2 sombra">
            <ul className="lista-cursos">
              <Curso
                imagen={imagenes[16].node.childImageSharp.fluid}
                titulo="Desarrollo Profesional de Temas y Plugins de WordPress"
                descripcion="Aprende a crear Temas y Plugins de WordPress, convierte tus diseños en HTML estático a Sitios Web Dinamicos con WordPress."
                videos="406"
                duracion="36"
                orden="1"
              />
              <Curso
                imagen={imagenes[11].node.childImageSharp.fluid}
                titulo="Desarrollo de Temas de WordPress con Bootstrap 4 y CMB2"
                descripcion="CMB2 es un framework completo para WordPress, te permitirá crear sitios web y hasta aplicaciones web sobre WordPress sin aprender nuevas tecnologías como Node o Laravel, sin duda la mejor opción para quien desea crear un proyecto grande y tiene ya conocimientos en WordPress"
                videos="264"
                duracion="19"
                orden="2"
              />
              <Curso
                imagen={imagenes[6].node.childImageSharp.fluid}
                titulo="Desarrollo de Tiendas Virtuales con WordPress y WooCommerce"
                descripcion="WooCommerce es la plataforma para E-Commerce más popular, aprende a administrar tu tienda virtual como un profesional con este curso así como crear un tema con Storefront, aprende a recibir pagos en línea para productos físicos y virtuales."
                videos="125"
                duracion="10"
                orden="3"
              />

              <Curso
                imagen={imagenes[13].node.childImageSharp.fluid}
                titulo="WordPress Avanzado Bloques Gutenberg Post Types y Taxonomías"
                descripcion="¿Estás listo para sacar el máximo provecho a WordPress? Crea 7 Plugins de WordPress y Bloques Nativos de Gutenberg en este curso 100% práctico."
                videos="125"
                duracion="10"
                orden="4"
              />

              <Curso
                imagen={imagenes[13].node.childImageSharp.fluid}
                titulo="Desarrollo de Plugins para WordPress con PHP, JS, CSS y HTML"
                descripcion="Aprende a Desarrollar Plugins para WordPress con PHP, JavaScript, HTML y CSS además de tips para vender tus plugins"
                videos="50"
                duracion="5"
                orden="5"
              />
            </ul>
          </div>
        </div>
      </section>

      <main className="bg-amarillo seccion-workshops py3">
        <div className="contenedor">
          <h2 className="mt2">
            Algunas <span>preguntas frecuentes </span>
          </h2>
          <ul className="lista-faq">
            <Pregunta
              pregunta="¿Debo tomar todos los cursos del Path o Plan?"
              respuesta="No es necesario, supongamos que decides crear un emprendimiento digital
            pero ya sabes crear Apps para Android y iOS, o tal vez tu idea aún no
            requiere una App porque estas viendo que tan viable es tu producto; por lo tanto tal vez el curso de React Native sería buena idea tomarlo más adelante y lo mismo aplica para los otros Paths."
            />
            <Pregunta
              pregunta="Aún no tengo claro que Path seguir pero quiero aprender a programar, ¿Qué cursos debo tomar?"
              respuesta="Comienza por los cursos de las Bases, seguramente con los proyectos que ahí creamos podrás definir a que te deseas dedicar."
            />
            <Pregunta
              pregunta="¿Es recomendable más de un Path? es decir ¿Puedo aspirar a tener trabajo y ser Freelancer?"
              respuesta="Obtendrás más provecho de los cursos si defines un solo camino a seguir, al igual que estudiar una carrera, tal vez estudias primero lo que te gusta y una segunda porque llama tu atención"
            />
            <Pregunta
              pregunta="¿Habrá más cursos y más rutas en el futuro?"
              respuesta="Cada curso que se vaya agregando se irá colocando en los Paths, asi que recuerda visitar este listado de forma continua, también habrá otros Paths como frontend, backend y mobile app developer en el futuro"
            />

            <li className="bg-blanco sombra p1">
              <h3>¿Tienes otra duda?</h3>
              <p>
                Escribeme a mi Twitter
                <a
                  href="https://twitter.com/JuanDevWP"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {" "}
                  @JuanDevWP{" "}
                </a>
                y te responderé a la brevedad cualquier duda que puedas tener.
              </p>
            </li>
          </ul>
        </div>
      </main>
    </Layout>
  )
}

export default IndexPage
